module.exports = __webpack_public_path__ + "static/media/cocacola.9e989a28.jpg";